import warning from 'warning';
import { darkShadows, lightShadows, unsupportedShadow } from '@/uptk/core/packages/style/index';

const MUIExpectedShadowCount = 25;
const supportedShadows = {
  light: lightShadows,
  dark: darkShadows
};

const defaultCreateShadow = ({
  type,
  index
}: any) => {
  if (
      index >= supportedShadows[type]?.length ||
        index < 0
  ) {
    return unsupportedShadow;
  }

  if (type != 'light' && type != 'dark') {
    return unsupportedShadow;
  }

  return supportedShadows[type][index];
}

export const createShadows = (
    type = 'light',
    createShadow = defaultCreateShadow
) => {
  if (import.meta.env.DEV) {
    warning(
        supportedShadows[type],
        `UI-toolkit: the shadow type \`${type}\` is not supported.`
    );
  }

  const shadowPalette = [];
  for (
      let shadowIndex = 0;
      shadowIndex < MUIExpectedShadowCount;
      shadowIndex++
  ) {
    shadowPalette[shadowIndex] = createShadow({
      type,
      index: shadowIndex,
      value: defaultCreateShadow({ type, index: shadowIndex })
    });
  }

  return shadowPalette;
};
